import type { ReactNode } from "react";

import { Chip, type ChipProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";

import { skillAccessTint, type SkillAccessToken } from "./skillAccessTokens";

/** A scope or audience value as a softly tinted chip with its icon. */
export function SkillAccessChip<T extends string>({
  token,
  label,
  ...chipProps
}: {
  token: SkillAccessToken<T>;
  /** Replaces the token's label, e.g. to add a dropdown arrow. */
  label?: ReactNode;
} & Omit<ChipProps, "label" | "icon" | "color" | "variant" | "size" | "sx">) {
  const { Icon } = token;
  return (
    <Chip
      {...chipProps}
      size="small"
      icon={<Icon aria-hidden sx={{ fontSize: 16 }} />}
      label={label ?? token.label}
      sx={(theme: Theme) => ({
        ...skillAccessTint(theme, token.color),
        "& .MuiChip-icon": { color: "inherit", opacity: 0.8 },
        "&.MuiChip-clickable:hover": skillAccessTint(theme, token.color, { hover: true }),
      })}
    />
  );
}
